<app-header
  [localStorageData]="localStorageData"
  [UserData]="userRoleData"
></app-header>

<div>
  <router-outlet></router-outlet>
</div>
